import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Carousel } from "components/Carousel";
import { ITXMedia } from "components/ITXMedia";
import { useDeviceCheck } from "hooks";
import { calculateTotalWidth } from "./functions";

const GalleryCarouselSettings = {
  draggable: true,
  dots: false,
  autoplay: false,
  speed: 2000,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  cssEase: "cubic-bezier(0.70,0.00,0.30,1.00)",
  gap: 8,
  adaptiveHeight: true,
  height: "100%",
  itemHeight: 680,
  variableWidth: false,
  width: "100%",
  itemWidth: 520,
  arrows: false,
  nextArrow: null,
  prevArrow: null,
  animation: "none",
  center: false,
  defaultSlider: 0,
  responsive: {
    breakpoint: 992,
    settings: {
      draggable: true,
      dots: false,
      autoplay: false,
      speed: 2000,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      cssEase: "cubic-bezier(0.70,0.00,0.30,1.00)",
      gap: 8,
      adaptiveHeight: true,
      height: "100%",
      itemHeight: 448,
      variableWidth: false,
      width: "100%",
      itemWidth: 343,
      arrows: false,
      nextArrow: null,
      prevArrow: null,
      animation: "none",
      center: false,
      defaultSlider: 0,
    },
  },
};
/**
 * CarouselMarket component
 * @param fields
 * @param lang
 * @returns {JSX.Element}
 * @constructor
 */
export const CarouselMarket = ({ fields, lang }) => {
  const { gallery } = fields;
  const { isMobile } = useDeviceCheck(
    GalleryCarouselSettings.responsive.breakpoint
  );

  const GalleryCarouselSettingsMarket = {
    ...GalleryCarouselSettings,
    itemHeight: gallery && gallery.length > 2 ? 680 : "100%",
    itemWidth: gallery && gallery.length > 2 ? 520 : "calc(50vw - .25rem)",
    responsive: {
      breakpoint: GalleryCarouselSettings.responsive.breakpoint,
      settings: {
        ...GalleryCarouselSettings.responsive.settings,
      },
    },
  };

  const getStyleMaxWidth = () => {
    if (isMobile || (gallery && gallery.length > 2)) {
      return {
        maxWidth: calculateTotalWidth({
          gallery,
          isMobile,
          heightMobile: 448,
          heightWeb: 680,
          isWidthAuto: false,
          isFixedWidth: true,
          gap: 8,
        }),
        position: "relative",
        left: "50%",
        transform: "translateX(-50%)",
      };
    } else {
      return {};
    }
  };

  const renderCarouselMarket = () => {
    if (gallery && gallery.length > 0) {
      return (
        <Carousel settings={GalleryCarouselSettingsMarket} lang={lang}>
          {gallery.map((item) => {
            const { id, url, name, width, height, type } =
              item.media.staticValue;
            const { caption } = item;
            return (
              <ITXMedia
                key={id}
                id={id}
                url={url}
                name={name}
                width={width || 1024}
                height={height || 574}
                alt={caption.staticValue || name}
                source={url}
                muted
                autoPlay
                loop
                locale={lang}
                type={type}
              />
            );
          })}
        </Carousel>
      );
    } else return null;
  };
  const [styles, setStyles] = useState({});
  useEffect(() => {
    setStyles(getStyleMaxWidth());
  }, []); //eslint-disable-line
  return (
    <div className={"galleryCarousel__carouselMarket"} style={styles}>
      {renderCarouselMarket()}
    </div>
  );
};

CarouselMarket.propTypes = {
  fields: PropTypes.shape({
    gallery: PropTypes.arrayOf(
      PropTypes.shape({
        media: PropTypes.shape({
          staticValue: PropTypes.shape({
            id: PropTypes.string,
            url: PropTypes.string,
            name: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            isDark: PropTypes.bool,
            type: PropTypes.oneOf(["Image", "Video", "Document"]),
            fileExtension: PropTypes.string,
          }),
        }),
        caption: PropTypes.shape({
          staticValue: PropTypes.string.isRequired,
        }),
        file: PropTypes.shape({
          staticValue: PropTypes.shape({
            id: PropTypes.string,
            url: PropTypes.string,
            name: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            isDark: PropTypes.bool,
            type: PropTypes.oneOf(["Image", "Video", "Document"]),
            fileExtension: PropTypes.string,
          }),
        }),
      }).isRequired
    ),
    carouselType: PropTypes.shape({
      staticValue: PropTypes.arrayOf(
        PropTypes.oneOf([
          "carousel" | "carousel_dots",
          "carousel_arrow",
          "carousel_market",
        ])
      ).isRequired,
    }),
    marginBottom: PropTypes.shape({
      staticValue: PropTypes.arrayOf(
        PropTypes.oneOf([
          "margin__bottom__0",
          "margin__bottom__80",
          "margin__bottom__160",
          "margin__bottom__240",
        ])
      ).isRequired,
    }),
  }).isRequired,
  lang: PropTypes.string.isRequired,
};
